import React from "react";
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

const Contact = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-vh-100 d-flex flex-column"
      style={{ backgroundColor: "#ffeae9", padding: "2rem" }}
    >
      <div className="mb-4">
        <button
          className="btn btn-light border rounded-circle"
          style={{ width: "42px", height: "42px" }}
          onClick={() => navigate("/")}
        >
          <img
            src="/arrow_back.png"
            alt="Go Back"
            style={{ width: "22px", height: "22px" }}
          />
        </button>
      </div>

      <div className="container bg-white rounded-4 shadow p-4">
        <h1 className="text-center mb-4">Contact Us</h1>
        <p className="fs-5">
          If you have any questions, feedback, or need support — feel free to reach out to us!
        </p>

        <ul className="list-unstyled fs-5 mt-4">
          <li className="mb-2">
            <strong>Email:</strong> help@edulink.com
          </li>
          <li className="mb-2">
            <strong>Phone:</strong> (321) 456-7890
          </li>
          <li>
            <strong>Address:</strong> Lahore University of Management Sciences
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Contact;
